<template>
  <div v-if="response!=null" class="gwrapper">
    <div :class="[response.large ? 'largeTitle' : 'title']">{{title}}</div>

    <div>
      <highcharts :options="chartOptions" ref="chartComponent"/>
      <TrendGoalComponent v-if="trendGoalValue!==null" :value="trendGoalValue"/>
    </div>
  </div>

</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from "highcharts/modules/solid-gauge";
import TrendGoalComponent from "./TrendGoalComponent";
import {mapState} from "vuex";

highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: 'GaugeWidget',

  components: {
    highcharts: Chart, TrendGoalComponent
  },

  props: {
    widgetData: Object
  },

  computed: {
    ...mapState(['chartRedrawCounter']),
  },

  data() {
    return {
      trendGoalValue: null,
      response: null,

      title: '',
      value: 0,


      chartOptions: {
        tooltip: { enabled: false },
        legend: { enabled: false },

        chart: {
          height: '70%',
          animation: false,
        },

        title: {
          text: '92.0',
          align: 'center',
          verticalAlign: 'middle',
          y: 50
        },

        exporting: {
          enabled: false
        },

        plotOptions: {

          series: {
            states: {
              inactive: {
                opacity: 1
              },
              hover: {
                enabled: false
              }
            }
          },

          pie: {
            borderWidth: 0.5,
            borderColor: null,

            center: ['50%', '100%'],
            dataLabels: {
              enabled: false
            },
            startAngle: -90,
            endAngle: 90,
            showInLegend: false,

            colors: []
          },

        },

        credits: {
          enabled: false
        },
        series: [{
          type: 'pie',
          innerSize: '60%',
          size: '180%',
          animation: false,
          data: []
        }]
      }

    }
  },


  methods: {
    requestData(requester) {
      requester.addExpressionRequest(this.dataCallback, this.widgetData.extname, this.widgetData.expr);
    },

    dataCallback(dto) {
//      console.log(dto)

      this.response = dto;

      this.title = dto.title;

      this.trendGoalValue = dto.trendGoalValue
      this.chartOptions.title.text = dto.svalue

      this.chartOptions.plotOptions.pie.colors = dto.pieColors
      this.chartOptions.series[0].data = dto.pieValues

    }
  },

  watch: {
    chartRedrawCounter: function () {
      if(this.$refs.chartComponent && this.$refs.chartComponent.chart) {
        this.$refs.chartComponent.chart.reflow()
      }
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gwrapper {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

div.title {
  padding-top: 1em;
  text-align: center;
}

div.largeTitle {
  text-align: center;
  font-size: 200%;
  margin-top: 20px;
}

</style>
